import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto',
      },
      toolbar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing(),
      },
      back: {
        textTransform: 'capitalize',
        '& .MuiButton-startIcon': {
          fontSize: 24,
          color: sicrediStyle.primarySicredi,
        }
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(),
      },
      pergunta: {
        '& .MuiFormHelperText-root': {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
        }
      },
      footer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        boxSizing: 'border-box',
        padding: `${theme.spacing() * 3}px ${theme.spacing()}px`,
      },
      submit: {
        backgroundColor: sicrediStyle.primarySicrediDark,
      },
    }),
  { name: 'Perguntar' }
);
